import type { LearningStoreActions } from "@/store/learning/actions";
import type { LearningStoreState } from "@/store/learning/state";
import type { FileNode } from "@webcontainer/api/dist/entities";
import { CodeCustomFunctionModel } from "~~/package/mapper/learning/model/CodeCustomFunctionModel";
import type FileData from "~~/package/types/FileData";

export const directoryActions = {
    addSelectedDirectoryFile(path: string, key: string, file: FileNode) {
        const index = (this as LearningStoreState).directory.selectedFiles
            .findIndex(selectedFile => selectedFile.path === path);
        if (index === -1) {
            (this as LearningStoreState).directory.selectedFiles = [
                ...(this as LearningStoreState).directory.selectedFiles.map(file => {
                    return (this as LearningStoreActions).setFileData(file, false);
                }),
                {path, name: key, file: {file: {contents: file.file.contents.toString()}}, isActive: true}
            ];
        } else {
            (this as LearningStoreState).directory.selectedFiles = (this as LearningStoreState).directory.selectedFiles
                .map((file, fileIndex) => {
                    return (this as LearningStoreActions).setFileData(file, fileIndex === index);
                });
        }
    },
    setFileData(file: FileData, isActive: boolean): FileData {
        return {
            ...file,
            file: { file: { contents: file.file.file.contents.toString() } },
            isActive
        };
    },
    updateSelectedDirectoryFile(fileData: {path: string, contents: string | Uint8Array} | null) {
        if (!fileData) return;
        const index = (this as LearningStoreState).directory.selectedFiles
            .findIndex(selectedFile => selectedFile.path === fileData.path);
        if (index !== -1) {
            (this as LearningStoreState).directory.selectedFiles[index].file.file.contents = fileData.contents;
            (this as LearningStoreState).editorKey += (this as LearningStoreState).editorKey;
        }
    },
    removeSelectedDirectoryFile(key: string, index: number) {
        const selectedFile = (this as LearningStoreState).directory.selectedFiles[index];
        if (selectedFile && selectedFile.name === key) {
            if (selectedFile.isActive && (this as LearningStoreState).directory.selectedFiles.length > 1) {
                const newActiveIndex = index <= 0 ? index + 1 : index - 1;
                (this as LearningStoreState).directory.selectedFiles[newActiveIndex].isActive = true;
            }

            (this as LearningStoreState).directory.selectedFiles = (this as LearningStoreState).directory.selectedFiles
                .filter((item, fileIndex) => fileIndex !== index);
        }
    },
    activeSelectedDirectoryFile(index: number) {
        (this as LearningStoreState).directory.selectedFiles = (this as LearningStoreState).directory.selectedFiles.map((file, fileIndex) => {
            return (this as LearningStoreActions).setFileData(file, fileIndex === index);
        });
    },
    addModifiedFiles(file: FileData) {
        (this as LearningStoreState).directory.modifiedFiles = (this as LearningStoreState).directory.modifiedFiles
            .filter(modifiedFile => !(modifiedFile.path === file.path && modifiedFile.name === file.name));

        (this as LearningStoreState).directory.modifiedFiles.push(file);
    },
    updateCustomFunctions(functions: string[], path: string) {
        if (path === "") {
            (this as LearningStoreState).customFunctions.push(new CodeCustomFunctionModel("", [...functions]));
        } else {
            const matchingCustomFunction = (this as LearningStoreState).customFunctions
                .filter(customFunction => customFunction.path === path)[0];

            if (matchingCustomFunction) {
                matchingCustomFunction.functions = functions;
            } else {
                (this as LearningStoreState).customFunctions.push(new CodeCustomFunctionModel(path, [...functions]));
            }
        }
    },
    clearCustomFunctions() {
        (this as LearningStoreState).customFunctions = [];
    }
};
